
Storage.prototype.parse = (key: string) => JSON.parse(localStorage[key] ?? null)